export enum AuditTrailType {
  SUBSCRIPTION_PRICE_MIGRATION_TRIGGERED = 'subscription_price_migration_triggered',
  SUBSCRIPTION_PRICE_MIGRATION_FAILED = 'subscription_price_migration_failed',
  SUBSCRIPTION_PRICE_MIGRATION_RESULT = 'subscription_price_migration_result',
  STRIPE_MIGRATION_TRIGGERED = 'STRIPE_MIGRATION_TRIGGERED',
  STRIPE_MIGRATION_FAILED = 'STRIPE_MIGRATION_FAILED',
  STRIPE_MIGRATION_SUCCESS = 'STRIPE_MIGRATION_SUCCESS',
}

export type AuditTrailPayloads = {
  [AuditTrailType.SUBSCRIPTION_PRICE_MIGRATION_TRIGGERED]: {
    userId: string;
    planId: string;
    newPrice: number;
  };
  [AuditTrailType.SUBSCRIPTION_PRICE_MIGRATION_FAILED]: {
    customerId: string;
    planId: string;
    newPrice: number;
    errorMessage: string;
  };
  [AuditTrailType.SUBSCRIPTION_PRICE_MIGRATION_RESULT]: {
    planId: string;
    newPrice: number;
    successCount: number;
    errorCount: number;
  };
  [AuditTrailType.STRIPE_MIGRATION_TRIGGERED]: {
    email: string;
  };
  [AuditTrailType.STRIPE_MIGRATION_SUCCESS]: {
    context: object;
    email: string;
  };
  [AuditTrailType.STRIPE_MIGRATION_FAILED]: {
    context: object;
    email: string;
  };
};

export interface AuditTrailDTO {
  id: string;
  type: AuditTrailType;
  timestamp: Date;
  userName: string;
  payload: AuditTrailPayloads[AuditTrailType];
}
